var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconReloadCupom = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22.031,
  height: 17.897,
  viewBox: "0 0 22.031 17.897",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_5734",
  "data-name": "Caminho 5734",
  d: "M10.771,3.25A8.37,8.37,0,0,0,3.635,7.273.827.827,0,0,0,3.879,8.4a.783.783,0,0,0,1.095-.25,6.8,6.8,0,0,1,5.8-3.27,6.946,6.946,0,0,1,6.837,6.414l-1.175-1.082a.78.78,0,0,0-1.119.062.828.828,0,0,0,.06,1.149l2.406,2.217a.777.777,0,0,0,1.059,0l2.407-2.217a.827.827,0,0,0,.06-1.149.778.778,0,0,0-1.119-.062l-1,.922a8.549,8.549,0,0,0-8.414-7.88ZM3.2,10.152a.781.781,0,0,0-.53.209L.26,12.579A.827.827,0,0,0,.2,13.727a.779.779,0,0,0,1.119.062L2.393,12.8a8.552,8.552,0,0,0,8.42,7.947,8.378,8.378,0,0,0,7.137-4.025.826.826,0,0,0-.243-1.123.783.783,0,0,0-1.095.25,6.8,6.8,0,0,1-5.8,3.272,6.945,6.945,0,0,1-6.83-6.336l1.09,1a.778.778,0,0,0,1.119-.062.829.829,0,0,0-.06-1.149L3.726,10.361a.776.776,0,0,0-.529-.209Z",
  transform: "translate(0.262 -3.05)",
  fill: "#173a6d",
  stroke: "#173a6d",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.4
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconReloadCupom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_reload_cupom.0817dff4.svg";
export { ForwardRef as ReactComponent };